export default {
  "news.detail.pageTitle": "News",

  "news.detail.head.siteName": "LINK-J",

  "news.list.head.title": "News",
  "news.list.head.description": "Latest News from LINK-J",
  "news.list.head.siteName": "LINK-J",
  "news.list.title": "News",
  "news.list.heading.title": "News",

  "news.categories.media": "LINK-J in the News",
  "news.categories.press-release": "Press Releases",
  "news.categories.news-events": " Events",
  "news.categories.overseas": "News from overseas",
  "news.categories.topics": "Topics",
  "news.categories.index": "News",
  "news.categories.program": "Training Programs",
  "news.categories.sponsorship": "Co-sponsorship",
  "news.categories.facilities": "Facilities",
  "news.archive.list.title": "Year",

  "news.bbt.detail.pageTitle": "",
  "news.bbt.detail.head.siteName": "",
  "news.bbt.list.head.title": "",
  "news.bbt.list.head.description": "",
  "news.bbt.list.head.siteName": "",
  "news.bbt.list.title": "",
  "news.bbt.list.heading.title": "",
  "news.bbt.list.index.breadcrumbs": "",
} as const;
